import Vue from 'vue';
import App from './App.vue';
import axios from '@/api/config'; //axios
Vue.prototype.$http = axios;

// ElementUI
import { Radio, Button as ElButton } from 'element-ui';
Vue.use(Radio).use(ElButton);
// Vant
import { Button, List, Cell, PullRefresh, Tab, Tabs, Icon, Search, Toast, Overlay, Form, Field, Empty } from 'vant';
Vue.use(Button).use(List).use(Cell).use(PullRefresh).use(Tab).use(Tabs).use(Icon).use(Search).use(Toast).use(Overlay).use(Form).use(Field).use(Empty);
// import Vconsole from './common/js/vconsole.min.js';
if (process.env.NODE_ENV === 'development') {
  // new Vconsole();
} else if (process.env.NODE_ENV === 'production') {
  // require('@/common/js/sjbbase.js');
}

import _double from 'lodash';
Vue.prototype.$_throttle = _double.throttle(
  (func, params) => {
    func(params);
  },
  200,
  {
    leading: false,
    trailing: true,
    // maxWait: 3000
  }
);
Vue.prototype.$_debounce = _double.debounce(
  (func, params) => {
    func(params);
  },
  500,
  {
    leading: true,
    trailing: false,
    // maxWait: 3000
  }
);

Vue.config.productionTip = false;
window.japp = new Vue({
  render: (h) => h(App),
}).$mount('#app');
